import { render, staticRenderFns } from "./CardDeviceDetail.vue?vue&type=template&id=7895ac96&scoped=true&"
import script from "./CardDeviceDetail.vue?vue&type=script&lang=js&"
export * from "./CardDeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./CardDeviceDetail.vue?vue&type=style&index=0&id=7895ac96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7895ac96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
